import { createApp } from 'vue'
import App from './app.vue'
import './registerServiceWorker'
import router from './router'

import './css/tailwind.css'

createApp(App).use(router).mount('#app')
